import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Apis } from "../../config";
import { updateWishlistCount } from "../wishList/wishListSlice";
import { updateCartCount } from "../cart/cartSlice";
import apiService from "../../services/ApiService";

const fetchProduct = createAsyncThunk('products/fetchProducts', async (data, { rejectWithValue }) => {
    try {
        let response;
        if (data?.isLoggedIn) {
            response = await apiService.get(Apis.GetUserProductsById(data));
        } else {
            response = await apiService.post(`${Apis.GetGlobalUnathProducts}?page=${data?.page}&size=${data?.size}`, data);
        }
        return response
        
    } catch (err) {
        return rejectWithValue(err?.message || 'Failed to fetch products');
    }
});

const fetchMoreProducts = createAsyncThunk('products/fetchMoreProducts', async (data, { rejectWithValue }) => {
    try {
        let response = await apiService.get(Apis.GetUserProductsById(data));
        return response;
    } catch (err) {
        return rejectWithValue(err?.message || 'Failed to fetch more products');
    }
});

const fetchShoppingActivityCounts = createAsyncThunk('shop/getCounts', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await apiService.get(Apis.GetShoppingActivityCounts(data));
        if (response?.message === "Success!") {
            dispatch(updateWishlistCount(response?.body?.wishlistCount));
            dispatch(updateCartCount(response?.body?.cartCount));
        }
        return response;
    } catch (err) {
        return rejectWithValue(err?.message || 'Failed to fetch shopping activity counts');
    }
});

export const productThunks = { fetchProduct, fetchMoreProducts, fetchShoppingActivityCounts };

